/* eslint-disable */
/// This file is auto generated - do not edit manually
export const DebugPlacements = 'Website.ConnectedContent.DebugPlacements';
export const DebugPreviewInfo = 'Website.ConnectedContent.DebugPreviewInfo';
export const DebugPreviewActivePeriod = 'Website.ConnectedContent.DebugPreviewActivePeriod';
export const DebugActivePeriod = 'Website.ConnectedContent.DebugActivePeriod';
export const DebugAdmin = 'Website.ConnectedContent.DebugAdmin';
export const DebugAdminLink = 'Website.ConnectedContent.DebugAdminLink';
